require('./css/app.scss');
import './images/trakked.svg';
import './images/slogan.png';